"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _asyncComponent = require("./asyncComponent");

var _asyncComponent2 = _interopRequireDefault(_asyncComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Dynamic import function for components

var PlumberSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/CitizenView/PlumberSearchCitizen").then(function (module) {
    return module.default;
  });
});
var UnpayableDemand = (0, _asyncComponent2.default)(function () {
  return import("../Screens/CitizenView/UnpayableDemand").then(function (module) {
    return module.default;
  });
});
var DemandStatus = (0, _asyncComponent2.default)(function () {
  return import("../Screens/CitizenView/DemandStatus").then(function (module) {
    return module.default;
  });
});
var DemandStatusDrainage = (0, _asyncComponent2.default)(function () {
  return import("../Screens/CitizenView/DemandStatusDrainage").then(function (module) {
    return module.default;
  });
});
var ViewBill = (0, _asyncComponent2.default)(function () {
  return import("../Screens/CitizenView/ViewBill").then(function (module) {
    return module.default;
  });
});

var DomesticSanction = (0, _asyncComponent2.default)(function () {
  return import("../Screens/DomesticSanctionDetails").then(function (module) {
    return module.default;
  });
});

var OnlineApplicationSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/OnlineDomesticApplicationSearch").then(function (module) {
    return module.default;
  });
});

var LorryConsumer = (0, _asyncComponent2.default)(function () {
  return import("../Screens/LorryConsumer").then(function (module) {
    return module.default;
  });
});
var LorryConsumerDataEntry = (0, _asyncComponent2.default)(function () {
  return import("../Screens/LorryConsumer/DataEntry").then(function (module) {
    return module.default;
  });
});

var DownloadForms = (0, _asyncComponent2.default)(function () {
  return import("../Screens/DownloadForms").then(function (module) {
    return module.default;
  });
});

var WaterSupplyDept = (0, _asyncComponent2.default)(function () {
  return import("../Screens/WaterSupplyDept").then(function (module) {
    return module.default;
  });
});

// Example route configuration
var routes = [{
  path: "egov-waterdrainage/citizen/PlumberSearch",
  component: PlumberSearch,
  needsAuthentication: true
}, {
  path: "egov-waterdrainage/citizen/UnpayableDemand",
  component: UnpayableDemand,
  needsAuthentication: true
}, {
  path: "egov-waterdrainage/citizen/DemandStatus",
  component: DemandStatus,
  needsAuthentication: true
}, {
  path: "egov-waterdrainage/citizen/DemandStatusDrainage",
  component: DemandStatusDrainage,
  needsAuthentication: true
}, {
  path: "egov-waterdrainage/citizen/ViewBill",
  component: ViewBill,
  needsAuthentication: true
}, {
  path: "egov-waterdrainage/citizen/OnlineDomesticApplication",
  component: DomesticSanction,
  needsAuthentication: true
}, {
  path: "egov-waterdrainage/citizen/OnlineApplicationSearch",
  component: OnlineApplicationSearch,
  needsAuthentication: true
}, {
  path: "egov-waterdrainage/citizen/LorryConsumer",
  component: LorryConsumer,
  needsAuthentication: true
}, {
  path: "egov-waterdrainage/citizen/LorryConsumer/DataEntry",
  component: LorryConsumerDataEntry,
  needsAuthentication: true
}, {
  path: "egov-waterdrainage/citizen/DownloadForms",
  component: DownloadForms,
  needsAuthentication: true
}, {
  path: "egov-waterdrainage/citizen/WaterSupplyDepartment",
  component: WaterSupplyDept,
  needsAuthentication: true
}];

exports.default = routes;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-waterdrainagecitizen/Routes/module-routes.js
// module id = 3525
// module chunks = 1137